var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');
var axios = require('axios');
var VueAxios = require('vue-axios');
var sw = require('js/lib/sw');
var _ = require('underscore');
Vue.use(VueAxios, axios);


var PO_LOADING_MESSAGE = 'Loading List of Production Orders...';
var NO_PO_MESSAGE = 'There are no Production Orders for this model';
var PRODUCT_LOADING_MESSAGE = 'Loading List of Products...';
var NO_PRODUCT_MESSAGE = 'There are no Products for this model';

module.exports = function ($fragment) {
    $fragment.swFindWithSelf("[data-sw-content-review-table]").each(function () {
        new Vue({
            el: this,
            data: {
                models: sw.data.models,
                modelIdToExpand: 0,
                poListExpanded: false,
                productListExpanded: false,
                totalModelCount: sw.data.totalModelCount,
                totalPageCount: sw.data.totalPageCount,
                currentPage: sw.data.currentPage,
                isPageLoading: false,
                multipleApproveComment: '',
                inputTypes : {
                    search: {
                        value: 'search',
                        text: 'Search',
                        show: true
                    },
                    add: {
                        value: 'add',
                        text: 'Add',
                        show: true
                    },
                    add_amz: {
                        value: 'add_amz',
                        text: 'Add To Marketplace Integrations',
                        show: true
                    }
                },
                inputTypeSelected: 'search',
                spinInput: null,
                searching: false
            },
            watch: {
              modelIdToExpand: function(){
                  if(this.productListExpanded) {
                      this.loadFragment()
                  }
              }
            },
            computed: {
                pageNumbers: function () {
                    var list = [];
                    for (var i = 1; i <= this.totalPageCount; i++) {
                        list.push(i);
                    }
                    return list;
                },
                modelsSelected: function () {
                    return _.some(this.models, 'selected', true);
                }
            },
            methods: {
                //This is needed to make sure ckeditor loads after the axios call to get products
                loadFragment: function() {
                    this.$nextTick(function () {
                        sw.trigger('sw-fragment-loaded', $(this.$el));
                    });
                },
                acceptMultiple: function () {
                    var listOfModelIdsToApprove = [];
                    var listOfModelIdsToApproveTypeSpecific = [];

                    for (var i = 0; i < this.models.length; i++) {
                        if (this.models[i].selected === true &&  '' == this.models[i].contentReviewType) {
                            listOfModelIdsToApprove.push(parseInt(this.models[i].modelId));
                        }
                        if (this.models[i].selected === true && 'AMZ' === this.models[i].contentReviewType) {
                            listOfModelIdsToApproveTypeSpecific.push({'AMZ': parseInt(this.models[i].entityId)});// should have some dynamic review types in the future
                        }
                    }

                    var self = this;

                    if (listOfModelIdsToApprove.length > 0 || listOfModelIdsToApproveTypeSpecific.length > 0) {
                        axios.post('/cs-portal/content-review/approve-multiple',
                            {
                                modelIds: listOfModelIdsToApprove,
                                comment: self.multipleApproveComment,
                                contentReviewEntityIds: listOfModelIdsToApproveTypeSpecific
                            })
                            .then(function (response) {
                                sw.notifications.success("Models approved!");
                                location.reload(true)
                            })
                            .catch(function (error) {
                                sw.notifications.error("Approving of Models Failed. Please try again");
                                location.reload()
                            })
                    }
                },
                addToUrl: function (pageNr) {
                    var url = '?pageNr=' + pageNr;
                    //this makes sure the url get's updated but the page does not refresh
                    history.pushState({
                        id: 'content-review-' + pageNr,
                    }, 'Inshape', url);
                    return url;
                },
                getNewPageContent: function (pageNr) {
                    var self = this;
                    self.isPageLoading = true;
                    this.addToUrl(pageNr);
                    axios.get('/cs-portal/content-review?pageNr=' + pageNr + '&returnJson=true')
                        .then(function (response) {
                            self.models = response.data;
                            self.isPageLoading = false;
                        })
                        .catch(function (error) {
                            sw.notifications.error(error);
                            self.isPageLoading = false;
                        })
                },
                movePageToRight: function () {
                    if (this.currentPage === this.totalPageCount) {
                        return this.currentPage;
                    }
                    this.currentPage += 1;
                    this.getNewPageContent(this.currentPage);
                    return this.currentPage;
                },
                movePageToLeft: function () {
                    if (this.currentPage === 1) {
                        return this.currentPage;
                    }
                    this.currentPage -= 1;
                    this.getNewPageContent(this.currentPage);
                    return this.currentPage;
                },
                moveToPage: function (pageNr) {
                    this.currentPage = pageNr;
                    this.getNewPageContent(pageNr);
                    return this.currentPage;
                },
                getPoDataFromModel: function (model) {
                    axios.get('/cs-portal/content-review/get-pos?modelId=' + model.modelId)
                        .then(function (response) {
                            model.productionOrdersLoaded = true;
                            //if there are no productionOrders we will show a message to the user
                            if (response.data.length === 0) {
                                return model.message = NO_PO_MESSAGE;
                            }
                            model.message = null;
                            model.productionOrders = response.data
                        })
                        .catch(function (error) {
                            sw.notifications.error("Failed getting Production Orders for Model with ID: " + model.entityId);
                        })
                },
                getProductDataFromModel: function (model) {
                    var self = this;
                    var endPoint = "/cs-portal/content-review/get-products?";
                    if(model.contentReviewType == 'AMZ') {
                        endPoint = endPoint+'productId=' + model.entityId + '&contentReviewType=AMZ';
                    } else {
                        endPoint = endPoint+'modelId=' + model.modelId;
                    }

                    axios.get(endPoint)
                        .then(function (response) {
                            model.productsLoaded = true;
                            //if there are no products we will show a message to the user
                            if (response.data.length === 0) {
                                return model.message = NO_PRODUCT_MESSAGE;
                            }
                            model.message = null;
                            model.products = response.data;
                            self.loadFragment()
                        })
                        .catch(function (error) {
                            console.log(error);
                            sw.notifications.error("Failed getting Products for Model with ID: " + model.entityId);
                        })
                },
                runValidation: function (product) {
                    axios.get('/cs-portal/content-review/validation?productId=' + product.productId)
                        .then(function (response) {
                            product.ipTerms = response.data;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                },
                callRejectProductionOrder: function (productionOrderId) {
                    //this function is in inshape.js file
                    //TODO refactor this function to use only VueJs
                    rejectProductionOrder(productionOrderId, null, null)
                },
                rejectProduct: function (entityId, reviewType) {
                    axios.get('/cs-portal/content-review/reject-product?productId=' + entityId + '&contentReviewType=' + reviewType)
                        .then(function(response) {
                            sw.notifications.success('Product rejected');
                            window.location.href = '/cs-portal/content-review';
                        })
                        .catch( function(error) {
                            if(error.response.data.message) {
                                sw.notifications.error(error.response.data.message);
                            } else {
                                sw.notifications.error('Whoops! Something went wrong. Please try again')
                            }
                        });
                },

                toggleTable: function (model, tableToToggle) {
                    switch (tableToToggle) {
                        case 'productionOrders':
                            // if the tab is already open we just need to close it
                            if (model.entityId === this.modelIdToExpand && this.poListExpanded) {
                                this.modelIdToExpand = 0;
                                this.poListExpanded = false;
                                return;
                            }
                            model.message = PO_LOADING_MESSAGE;
                            //we only want to fetch data if we didn't do that before
                            if (!model.productionOrdersLoaded) {
                                this.getPoDataFromModel(model)
                            } else if (model.productionOrders.length === 0) {
                                model.message = NO_PO_MESSAGE;
                            } else {
                                model.message = null;
                            }
                            this.modelIdToExpand = model.entityId;
                            this.poListExpanded = true;
                            this.productListExpanded = false;
                            break;
                        case 'products':
                            // if the tab is already open we just need to close it
                            if (model.entityId === this.modelIdToExpand && this.productListExpanded) {
                                this.modelIdToExpand = 0;
                                this.productListExpanded = false;
                                return;
                            }
                            model.message = PRODUCT_LOADING_MESSAGE;
                            //we only want to fetch data if we didn't do that before
                            if (!model.productsLoaded) {
                                this.getProductDataFromModel(model)
                            } else if (model.products.length === 0) {
                                model.message = NO_PRODUCT_MESSAGE;
                            } else {
                                model.message = null;
                            }
                            this.modelIdToExpand = model.entityId;
                            this.poListExpanded = false;
                            this.productListExpanded = true;
                            break;
                    }
                },
                searchOrAdd: function(type) {
                    let self = this;
                    self.productListExpanded = false;
                    self.poListExpanded = false;
                    self.modelIdToExpand = 0;
                    switch(type) {
                        case 'search':
                            axios.get('/cs-portal/content-review/get-models?productSpin=' + self.spinInput)
                                .then(function(response) {
                                    self.models = response.data;
                                    self.searching = true;
                                });
                            break;
                        case 'add':
                            axios.get('/cs-portal/content-review/add-product?productSpin=' + self.spinInput)
                                .then(function(response) {
                                    sw.notifications.success('Product Added to the queue');
                                    window.location.href = '/cs-portal/content-review';
                                })
                                .catch( function(error) {
                                    if(error.response.data.message) {
                                        sw.notifications.error(error.response.data.message);
                                    } else {
                                        sw.notifications.error('Whoops! Something went wrong. Please try again')
                                    }
                                });
                            break;
                        case 'add_amz':
                            axios.get('/cs-portal/content-review/add-product?productSpin=' + self.spinInput + '&contentReviewType=AMZ')
                                .then(function(response) {
                                    sw.notifications.success('Product Added to the queue');
                                    window.location.href = '/cs-portal/content-review';
                                })
                                .catch( function(error) {
                                    if(error.response.data.message) {
                                        sw.notifications.error(error.response.data.message);
                                    } else {
                                        sw.notifications.error('Whoops! Something went wrong. Please try again')
                                    }
                                });
                            break
                    }
                },
                clearSearch: function() {
                    this.models = sw.data.models;
                    this.searching = false;
                    this.spinInput = null;
                    this.productListExpanded = false;
                    this.poListExpanded = false;
                    this.modelIdToExpand = 0;
                }
            },
        })
    });
};